// All applications constants here
export const BANNER_CONTAINER_ID: string = "#diva-banner-container";

export const HttpStatus = {
  FORBIDDEN: 403,
  UNAUTHORIZED: 401,
} as const;